import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

import { GddProduct } from '@/vue3/api/models';

import { useAxios } from '@/vue3/hooks/axiosHook';

export const useGddProductService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const getAllGddProducts = async (): Promise<GddProduct[]> => {
        const res = await axios.get(`${apiUrl}/gdd-product`);
        return res.data;
    };

    const getGddProduct = async (id: number): Promise<GddProduct> => {
        const res = await axios.get(`${apiUrl}/gdd-product/${id}`);
        return res.data;
    };

    const createGddProduct = async (
        gddProduct: GddProduct,
    ): Promise<GddProduct> => {
        const res = await axios.post(`${apiUrl}/gdd-product`, gddProduct);
        return res.data;
    };

    const updateGddProduct = async (
        gddProduct: GddProduct,
    ): Promise<GddProduct> => {
        const res = await axios.put(`${apiUrl}/gdd-product`, gddProduct);
        return res.data;
    };

    const deleteGddProduct = async (id: number): Promise<GddProduct> => {
        const res = await axios.deleteId(`${apiUrl}/gdd-product/${id}`);
        return res.data;
    };

    const forceUpdateGDD = async () => {
        const res = await axios.get(`${apiUrl}/gdd/updateRemainingGddValue`)
        if(res.status == 200 || res.status == 201){
            return res.data;
        }
        return false;
    }

    return {
        getAllGddProducts,
        getGddProduct,
        createGddProduct,
        updateGddProduct,
        deleteGddProduct,
        forceUpdateGDD
    };
};
